import { useQuery } from 'data-fetching-client';
import { APP_STATUS_QUERY } from '../../../__generated__/chirp/com/hubspot/video/conference/component/rpc/ui/service/v1/WebinarFormsAppStatusChirpUIService.dfc';
import I18n from 'I18n';
export const useAppStatus = () => {
  var _data$appStatus;
  const {
    loading,
    error,
    data
  } = useQuery(APP_STATUS_QUERY);
  const appStatusData = data === null || data === void 0 || (_data$appStatus = data.appStatus) === null || _data$appStatus === void 0 ? void 0 : _data$appStatus.appStatus.map(status => {
    let appName = status.appName;
    if (!appName) {
      appName = I18n.text('videoConference.settings.webinarsForm.unknownIntegrationName');
    }
    return Object.assign({}, status, {
      appName
    });
  });
  return {
    isLoadingAppStatus: loading,
    appStatusError: error,
    appStatusData
  };
};